import * as angular from 'angular';
import { gpCommon } from '../app-common/app';

export const gpDataApp = angular.module("gpDataApp",
    [
        gpCommon.name,
    ]);
